import { doFetch } from "./doFetch";

/**
 * Wraps fetch and adds common elements such as the Authorization header and the X-Version header.
 * If providing a body, this function expects form data (Content-Type is set to multipart/form-data)
 * @param url 
 * @param requestInit 
 * @returns 
 */
export const doFetchFormDataPost = (url: string, requestInit: RequestInit) => {
  return doFetch(`${url}`, {
    ...requestInit,
    method: "POST",
    headers: {
      "accept": "application/json"
    },
    body: requestInit.body ?? new FormData()
  });
}